import { render, staticRenderFns } from "./attachment.vue?vue&type=template&id=1a4916be"
import script from "./attachment.vue?vue&type=script&lang=js"
export * from "./attachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a4916be')) {
      api.createRecord('1a4916be', component.options)
    } else {
      api.reload('1a4916be', component.options)
    }
    module.hot.accept("./attachment.vue?vue&type=template&id=1a4916be", function () {
      api.rerender('1a4916be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/attachment.vue"
export default component.exports